export default "__VITE_ASSET__ba8ce6fc__"